import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const SfReceiptViewSingle = () => {
   useAuthRedirect();
  const { sfNo } = useParams();
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");

  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
         Swal.fire({
                          title: "Fetching Receipt Details",
                          html: `
                            <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                              <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                            </div>
                            <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Receipt Details...</p>
                          `,
                          showConfirmButton: false,
                          allowOutsideClick: false,
                          didOpen: () => {
                            const style = document.createElement("style");
                            style.innerHTML = `
                              @keyframes progressBar {
                                0% { width: 0% }
                                50% { width: 100% }
                                100% { width: 0% }
                              }
                            `;
                            document.head.appendChild(style);
                          },
                        });
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/sfReceiptModify_detailsHeader?sfNo=${sfNo}&branch=${branch}`
        );
        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;
          const storeReqHeader = {
            sfNo: items[0].sfReceiptsHeader_number || "N/A",
            date: items[0].sfReceiptsHeader_date || "N/A",
            indentRef: items[0].sfReceiptsHeader_indentReferenceNumber || "N/A",
            remarks: items[0].sfReceiptsHeader_remarks || "N/A",
            
          };
          setHeader(storeReqHeader);
        }
        Swal.close();
      } catch (error) {
         Swal.close();
                          console.error("Error fetching Receipt Details. Please try again:", error);
                          Swal.fire({
                            icon: "error",
                            title: "Oops!",
                            text: "Error fetching Receipt Details. Please try again",
                          });
      }
    };

    fetchIndentDetails();
  }, [sfNo, branch]);


  useEffect(() => {
    const fetchIndentBottom = async () => {
      try {
        
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/sfReceiptModify_bottomDetails?sfNo=${sfNo}&branch=${branch}`);
            setData(response.data.bottomDetails);
        
      } catch (error) {
        Swal.close();
                          console.error("Error fetching Receipt Details. Please try again:", error);
                          Swal.fire({
                            icon: "error",
                            title: "Oops!",
                            text: "Error fetching Receipt Details. Please try again",
                          });
      }
    };

    fetchIndentBottom();
  }, [sfNo, branch]);


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
                     <div className="back-div">
          <h2 className="add-txt">Shop Floor Receipts - View</h2>
          <Link to='/inventory/sfReceiptsView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>Receipt No :</label>
                <input type="text" name="indentNo" value={header.sfNo} readOnly />
              </div>
              <div className="form-group">
                <label>Receipt Date :</label>
                <input type="text"value={header.date ? new Date(header.date).toISOString().split("T")[0] : ""} readOnly />
              </div>
            </div>

           

            <div className="form-row">
            <div className="form-group">
                <label>Indent Reference :</label>
                <input type="text" value={header.indentRef} readOnly/>
              </div>

              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={header.remarks} readOnly/>
              </div>
            </div>
           

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Part No</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th> Received Qty</th>
                    <th>Price</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    <>
                      {data.map((item, index) => {
                        const value = item.sfReceiptsDetail_price * item.sfReceiptsDetail_receivedQuantity;
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.sfReceiptsDetail_itemCode}</td>
                            <td>{item.itemmaster_drawingNumber}</td>
                            <td>{item.itemmaster_name}</td>
                            <td>{item.itemmaster_uom}</td>
                            <td>{item.sfReceiptsDetail_receivedQuantity}</td>
                            <td>{item.sfReceiptsDetail_price}</td>
                            <td>{value.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={7}><strong>Total Value</strong></td>
                        <td>
                          <strong>
                            {data
                              .reduce((acc, item) => acc + item.sfReceiptsDetail_price * item.sfReceiptsDetail_receivedQuantity, 0)
                              .toFixed(2)}
                          </strong>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SfReceiptViewSingle;
